import type { Client } from "trailbase";
import { createRating, deleteRating, updateRating } from "../data/api";
import type { NewRating, RatingRecord, RatingScore } from "./types";

export const saveRating = async (
  client: Client,
  nameId: string,
  userId: string,
  score: RatingScore,
  reason: string,
  existing: RatingRecord | undefined,
): Promise<void> => {
  const input: NewRating = { name_id: nameId, user_id: userId, score, reason };
  if (existing === undefined) {
    await createRating(client, input);
    return;
  }
  await updateRating(client, existing.id, input);
};

export const clearRating = async (
  client: Client,
  existing: RatingRecord,
): Promise<void> => {
  await deleteRating(client, existing.id);
};
